import React from "react";
import "./ParentComponent.css";
import NavbarSuperAdmin from "../../../components/navbar/NavbarSuperAdmin";
import { GoToBack } from "../../../components/ui/GoToBack header/GoToBackR5.js";
import { useLocation } from "react-router-dom";
import Map from "../../maps/mapcomponent.js";
import { useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

const ViewGingleTripData = () => {
  const location = useLocation();
  const { transactionId, imei, vin, start, end } = location.state || {};

  let [data, setdata] = useState([]);

  dayjs.extend(utc);
  dayjs.extend(timezone);

  //  console.log("data from map is :", data);
  // console.log("transid is:", data[0].transactionId);

  return (
    <>
      <div
        className="container-fluid"
        style={{ width: "100%", height: "100%", padding: 0, margin: 0 }}
      >
        <NavbarSuperAdmin />

        <GoToBack>Maps</GoToBack>

        {/* Main Row */}
        <div
          className="row"
          style={{
            marginLeft: "50px",
            marginTop: "10px",
            paddingTop: "10px",
            minHeight: "calc(100vh - 100px)",
            backgroundColor: "#f8f9fa",
          }}
        >
          {/* <div className="col-md-1" style={{ paddingLeft: "15px" }}>
            </div> */}
          {/* Map Column - 9 cols */}
          <div className="col-md-9" style={{ paddingRight: "5px" }}>
            <Map
              transactionId={transactionId}
              imei={imei}
              vin={vin}
              start={start ? start : "null"}
              end={end ? end : "null"}
              setdata={setdata}
              style={{ width: "90%", height: "100%", marginLeft: "100 px" }}
            />
          </div>

          {/* Right Form / Sidebar - 2 cols */}
         <div
  className="col-md-3"
  style={{ paddingLeft: "0px", height: "100%" }}
>
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      padding: "14px",
      backgroundColor: "#d7d1d1ff",
      borderLeft: "1px solid #ccc",
      borderRadius: "6px",
      minHeight: "115%", // ⬅️ increased height by about one-third
      fontSize: "13px",
    }}
  >
    {/* Title inside the box */}
    <div
      style={{
        fontWeight: "bold",
        color: "black",
        textAlign: "center",
        marginBottom: "10px",
        fontSize: "14px",
        textTransform: "uppercase",
      }}
    >
      Trip Details
    </div>

    {[
      { label: "Transaction ID", value: data[0]?.transactionId },
      {
        label: "Start Time",
        value: data[0]?.startTime
          ? dayjs.utc(data[0].startTime).utcOffset(-7).format("YYYY-MM-DD hh:mm:ss A")
          : "N/A",
      },
      {
        label: "End Time",
        value: data[0]?.endTime
          ? dayjs.utc(data[0].endTime).utcOffset(-7).format("YYYY-MM-DD hh:mm:ss A")
          : "N/A",
      },
      { label: "Average Speed", value: data[0]?.averageSpeed?.toFixed?.(2)+" "+"miles" ?? "N/A" } ,
      { label: "Max Speed", value: data[0]?.maxSpeed?.toFixed?.(2)+" "+"miles" ?? "N/A" },
      {
        label: "Start Odometer",
        value:
          data[0]?.startOdometer !== undefined
            ? data[0].startOdometer.toFixed(2)
            : "N/A",
      },
      {
        label: "End Odometer",
        value:
          data[0]?.endOdometer !== undefined
            ? data[0].endOdometer.toFixed(2)
            : "N/A",
      },
      { label: "IMEI", value: data[0]?.imei },
      { label: "VIN", value: vin },
    ].map((item, index) => (
      <div
        key={index}
        style={{
          marginBottom: "10px",
          padding: "8px 10px",
          backgroundColor: "#fff",
          borderRadius: "5px",
          boxShadow: "0 1px 1px rgba(0,0,0,0.08)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          lineHeight: "1.4", // ⬅️ slightly taller lines for better balance
        }}
      >
        <span style={{ fontWeight: "600", color: "#333" }}>{item.label}:</span>
        <span style={{ fontWeight: "500", color: "#555", textAlign: "right" }}>
          {item.value || "N/A"}
        </span>
      </div>
    ))}
  </div>
</div>

        </div>
      </div>
    </>
  );
};

export default ViewGingleTripData;
